<template>
  <div class="editable-label">
    <template v-if="!isEditing">
      <div class="default-label">
        <div class="default-label-left">
          <div :style="{'margin-top': icon === 'AlertCircleIcon' ? '6px' : '0'}">
            <FeatherIcon 
              v-b-tooltip.hover
              :title="tooltipTitle"
              :icon="icon" 
              size="18" 
              class="mr-1" 
            />
          </div>
          <p v-if="!loadingData" class="labelName">
            <b-table
              v-if="defaultData && typeof defaultData == 'object'"
              class="meta-table"
              fixed
              thead-class="hidden"
              :items="items"
            >
              <template #cell(value)="data">
                <a
                  v-if="typeof formatValue(data.value) === 'string' && formatValue(data.value).includes('http')"
                  v-b-tooltip.hover
                  :title="formatValue(data.value)"
                  class="meta-table-cell"
                  :href="formatValue(data.value)"
                  target="_blank"
                >
                  {{ formatValue(data.value) || '-' }}
                </a>
                <div
                  v-else
                  v-b-tooltip.hover
                  class="meta-table-cell"
                  :title="getTranslationValue(data.value, data)"
                >
                  {{ getTranslationValue(data.value, data) }}
                </div>
              </template>
            </b-table>
            <span v-else>
              {{ defaultData || this.$t("ticket.no_information") }}
            </span>
          </p>
          <p v-else class="labelName">
            {{ $t("general.loading") }}
          </p>
        </div>

        <div v-if="editable" class="default-label-right">
          <FeatherIcon
            v-b-tooltip.hover
            icon="Edit2Icon"
            size="18"
            class="clickable-icon"
            :title="$t('ticket.edit')"
            @click="
              isEditing = true;
              inputData = defaultData;
            "
          />
        </div>
      </div>
    </template>
    <template v-else>
      <BForm class="edit-label" @submit.prevent="handleEdit">
        <div class="edit-label-left" style="position: relative">
          <FeatherIcon :icon="icon" size="18" class="mr-1 clickable-icon" />
          <template v-if="!loading">
            <div
              style="width: 100%"
              :class="{ error: v$.inputData.$errors.length }"
            >
              <b-form-input
                v-model.trim="inputData"
                autocomplete="off"
                class="input-edit-form"
                :placeholder="placeholder"
                size="md"
                @keydown.esc="isEditing = false"
                @input="v$.inputData.$touch()"
                @blur="v$.inputData.$touch()"
              />
              <FeatherIcon
                v-b-tooltip.hover
                :title="$t('ticket.cancel')"
                icon="XIcon"
                size="18"
                class="clickable-icon input-edit-icon-cancel"
                @click="
                  isEditing = false;
                  inputData = '';
                "
              />
              <label :for="`submit-button-${typeData}`">
                <FeatherIcon
                  v-b-tooltip.hover
                  :title="$t('ticket.save')"
                  icon="CheckIcon"
                  size="18"
                  class="clickable-icon input-edit-icon-save"
                />
              </label>
              <b-button
                :id="`submit-button-${typeData}`"
                style="display: none"
                type="submit"
              />
              <span v-for="error of v$.inputData.$errors" :key="error.$uid">
                <span style="color: #8d5185">
                  {{ error.$message }}
                </span>
              </span>
            </div>
          </template>
          <template v-else> Loading... </template>
        </div>
        <div class="edit-label-right">
          <!--          <FeatherIcon-->
          <!--            v-b-tooltip.hover-->
          <!--            title="cancel"-->
          <!--            icon="XIcon"-->
          <!--            size="24"-->
          <!--            class="clickable-icon"-->
          <!--            @click="-->
          <!--              isEditing = false;-->
          <!--              inputData = '';-->
          <!--            "-->
          <!--          />-->
          <!--          <label :for="`submit-button-${typeData}`">-->
          <!--            <FeatherIcon-->
          <!--              v-b-tooltip.hover-->
          <!--              title="Save"-->
          <!--              icon="CheckIcon"-->
          <!--              size="24"-->
          <!--              class="clickable-icon"-->
          <!--            />-->
          <!--          </label>-->

          <!--          <b-button-->
          <!--            :id="`submit-button-${typeData}`"-->
          <!--            style="display: none"-->
          <!--            type="submit"-->
          <!--          />-->
        </div>
      </BForm>
    </template>
  </div>
</template>

<script>
import { BTooltip, BFormInput, BForm, BButton, BTable } from "bootstrap-vue";
import CustomerRepository from "@/repositories/Api/CustomerRepository";
import Toast from "@/libs/toast";

import { useVuelidate } from "@vuelidate/core";
import { required, email, numeric, maxLength } from "@vuelidate/validators";
import {
  requiredValidate,
  maxValidate,
  emailValidate,
  numericValidate,
} from "@/libs/i18n/i18n-validator";

function handleValidate(type) {
  switch (type) {
    case "email":
      return {
        requiredValidate,
        emailValidate,
        maxLength: maxValidate(30),
      };
    case "number":
      return {
        requiredValidate,
        numericValidate,
        maxLength: maxValidate(15),
      };
    default:
      return {
        requiredValidate,
        maxLength: maxValidate(30),
      };
  }
}

export default {
  name: "EditableLabel",
  components: {
    BTooltip,
    BFormInput,
    BForm,
    BButton,
    BTable,
  },
  props: {
    icon: {
      type: String,
      required: "UserIcon",
    },
    placeholder: {
      type: String,
      default: "Enter",
    },
    defaultData: {
      type: [String, Number, Object],
      default: "Loading",
    },
    editable: {
      type: Boolean,
      default: false,
    },
    metaData: {
      type: String,
      default: "id",
    },
    validateData: {
      type: String,
      default: "text",
    },
    typeData: {
      type: String,
      default: "text",
    },
    store: {
      type: Object,
      default: null,
    },
    loadingData: {
      type: Boolean,
      default: false,
    },
    activeChannel: {
      type: Object,
      default: () => ({}),
    },
    tooltipTitle: {
      type: String,
      default: "",
    },
  },
  // setup(props) {
  //   const ticketStore = useTicketStore()
  //   const isEditing = computed(() => {
  //     if (props.typeData === 'number') {
  //       return ticketStore.editableStatue.isEditablePhone
  //     }
  //     if (props.typeData === 'email') {
  //       return ticketStore.editableStatue.isEditableEmail
  //     }
  //     if (props.typeData === 'text') {
  //       return ticketStore.editableStatue.isEditableName
  //     }
  //     return false
  //   })
  //
  //   return {
  //     isEditing,
  //   }
  // },
  computed: {
    translations() {
      return {
        buildingName: this.$t('general.building_name'),
        roomName: this.$t('general.room_name'),
        enterpriseName: this.$t('general.enterprise_name'),
        fullAddress: this.$t('general.address'),
        merchantOID: this.$t('general.merchant_oid'),
        employeeOID: this.$t('general.employee_oid'),
        name: this.$t('field.name'),
        profileUrl: this.$t('general.profile'),
        buildingType: this.$t('general.building_type'),
        userId: this.$t('general.user_id'),
        source: this.$t('general.source'),
      }
    },
    items() {
      const items = [];
      for (const field in this.defaultData) {
        items.push({ field: this.translations?.[field] || field, value: this.defaultData?.[field] });
      }
      return items;
    },
  },
  data() {
    return {
      loading: false,
      isEditing: false,
      inputData: "",
    };
  },
  setup() {
    return { v$: useVuelidate() };
  },
  validations() {
    return {
      inputData: handleValidate(this.validateData),
      // inputData: props.validateData === "text" return
    };
  },
  watch: {
    activeChannel: {
      handler(newValue, oldValue) {
        this.isEditing = false;
      },
      deep: true,
    },
  },
  methods: {
    getTranslationValue(value, data) {
      if (data.item.field === this.$t('general.source')) {
        return this.$t(`general.${value.toLowerCase()}`);
      }
      return this.formatValue(value) || '-';
    },
    appLocale() {
      return this.$i18n?.locale?.split('-')[0] || 'en';
    },
    formatValue(value) {
      if (value && typeof value === 'object') {
        const locale = this.appLocale();
        const translationKeys = ['en', 'zh', 'km', 'vi'];
        const hasTranslationShape = translationKeys.some(k => Object.prototype.hasOwnProperty.call(value, k));
        if (hasTranslationShape) {
          const byLocale = value[locale];
          if (byLocale && typeof byLocale === 'string' && byLocale.trim()) return byLocale;
          for (const k of translationKeys) {
            const v = value[k];
            if (v && typeof v === 'string' && v.trim()) return v;
          }
          return '';
        }
        try {
          return JSON.stringify(value);
        } catch (e) {
          return '';
        }
      }
      return value ?? '';
    },
    makeSuccessToast(append = false) {
      Toast.fire({
        icon: "success",
        title: this.$t("ticket.update_ticket_successfully_message"),
      });
      // this.$bvToast.toast(this.$t('ticket.update_ticket_successfully_message'), {
      //   title: this.$t('ticket.update_ticket_successfully'),
      //   autoHideDelay: 4000,
      //   appendToast: append,
      //   variant: 'success',
      // })
    },
    makeExistingToast(append = false) {
      Toast.fire({
        icon: "error",
        title: this.$t("ticket.update_ticket_existing_message"),
      });
      // this.$bvToast.toast(this.$t('ticket.update_ticket_existing_message'), {
      //   title: this.$t('ticket.update_ticket_existing'),
      //   autoHideDelay: 4000,
      //   appendToast: append,
      //   variant: 'danger',
      // })
    },
    makeFailToast(append = false) {
      Toast.fire({
        icon: "error",
        title: this.$t("ticket.update_ticket_failed_message"),
      });

      // this.$bvToast.toast(this.$t('ticket.update_ticket_failed_message'), {
      //   title: this.$t('ticket.update_ticket_failed'),
      //   autoHideDelay: 4000,
      //   appendToast: append,
      //   variant: 'danger',
      // })
    },

    handleEdit() {
      if (this.v$.$invalid) {
        this.v$.$touch();
        return;
      }
      console.log("handleEdit");
      this.loading = true;
      CustomerRepository.updateCustomerProfile(this.metaData, {
        [this.typeData]: this.inputData,
      })
        .then((res) => {
          const { data } = res.data;
          console.log("Update Result", data);

          if (this.typeData === "email") {
            if (data.type === "new") {
              this.defaultData = this.inputData;
              this.$emit("update", data);
              this.makeSuccessToast(true);
              this.isEditing = false;
            } else if (data.type === "exist") {
              this.makeExistingToast(true);
            }
          } else {
            this.defaultData = this.inputData;
            this.$emit("update", data);
            this.makeSuccessToast(true);
            this.isEditing = false;
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.makeFailToast(true);

          console.log(err);
        });
    },
    handleCloseEdit() {
      this.isEditing = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.labelName {
  margin-bottom: unset;
  //font-weight: bold;
}

.editable-label {
  .default-label {
    display: flex;
    justify-content: space-between;

    .default-label-left {
      display: flex;
    }

    .default-label-right {
    }
  }

  .edit-label {
    display: flex;
    justify-content: space-between;

    .edit-label-left {
      display: flex;
      flex: 1;
    }

    .edit-label-right {
      display: flex;
      gap: 1em;
    }
  }
}

.input-edit-form {
  padding-right: 5em;
}

.input-edit-icon {
  position: absolute;
  top: 0.75em;
}

.input-edit-icon-save {
  @extend .input-edit-icon;
  right: 0.5em;
}

.input-edit-icon-cancel {
  @extend .input-edit-icon;
  right: 2.5em;
}

.clickable-icon {
  cursor: pointer;
}

.header-subtitle {
  font-size: 0.85em;
  color: gray;
}

.label-container {
  display: flex;
  gap: 1em;
}

.container-right_sidebar {
  padding: 1.5rem;
}
</style>

<style lang="scss">
.meta-table td {
  padding: 0.5em;
}

.meta-table-cell {
  // line-clamp-1
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
